// extracted by mini-css-extract-plugin
export default {"licenseType":"HeaderTab-module_licenseType__wKDQt","relatedProducts":"HeaderTab-module_relatedProducts__huKKW","firstColumn":"HeaderTab-module_firstColumn__GS85l"};